import { RowWrapper } from "./RowWrapper";
import { TextCell } from "./TextCell";
import { Box, Stack } from "@mui/material";
import { useAppSelector } from "../../../hooks";

export const CompanyRoleTableHeader = () => {
  const { isEditor } = useAppSelector((state) => state.company.userRoles);

  return (
    <RowWrapper>
      <Box maxWidth={"200px"} minWidth={"200px"}>
        <TextCell
          isHighlighted={true}
          value="Role"
          maxWidth={"200px"}
          minWidth={"200px"}
          tooltip="Probable role of the contact in a buying committee."
        />
      </Box>
      <Stack flexDirection="row" alignItems="center" flexGrow={1}>
        <TextCell
          isHighlighted={true}
          value="Name"
          maxWidth={"48%"}
          minWidth={"120px"}
        />
        <TextCell
          isHighlighted={true}
          value="Seniority"
          maxWidth={"20%"}
          minWidth={"100px"}
        />
        <TextCell
          isHighlighted={true}
          value="Engagement"
          maxWidth={"12%"}
          minWidth={"124px"}
          justifyContent="flex-end"
          tooltip="Average engagement rate of all identified BC members within the account. Engagement rate refers
           to how active and efficient the communication with identified BC members is, based on phone calls, emails,
            meetings, and communication recency data."
        />
        <TextCell
          isHighlighted={true}
          value="Committee"
          maxWidth={"12%"}
          minWidth={"144px"}
          justifyContent="flex-end"
          tooltip="Probability rate of the contact being involved in the buying committee."
        />
        <TextCell
          isHighlighted={true}
          value="Cluster"
          maxWidth={"12%"}
          minWidth={"104px"}
          justifyContent="flex-end"
          tooltip="Probability rate of the contact being involved in the buying cluster - a narrow group of final
           decision makers inside the buying committee."
        />
        {isEditor && <div style={{ width: "48px", minWidth: "48px" }} />}
      </Stack>
    </RowWrapper>
  );
};
